import React from "react";
import PageHeader from "../PageHeader";
import heroBackImage from "../images/hero/hero.webp";
import "../css/legal.css";

const CertificatesPage = () => {
  const breadcrumbLinks = [
    { label: "الرئيسية", path: "/" },
    { label: "الشهادات", path: "/certificates" },
  ];

  return (
    <>
      <PageHeader
        title="الشهادات"
        bgImage={heroBackImage}
        breadcrumbs={breadcrumbLinks}
      />

      <section className="legal-section">
        <div className="container">
          <div className="legal-wrapper">
            <p className="legal-intro">
              يركّز عمل نبض كير على مساعدة عملائنا في الحصول على الشهادات
              اللازمة لمنتجاتهم ومنشآتهم بما يتوافق مع المتطلبات المحلية
              والدولية، مع الحرص على توثيق الخبرات والإنجازات في هذا المجال.
            </p>

            <div className="legal-block">
              <h2 className="legal-block-title">شهادات مطابقة المنتجات</h2>
              <p>
                ندعم عملاءنا في الحصول على شهادات المطابقة للمنتجات الغذائية
                والتجميلية والمنتجات الخاضعة للرقابة، سواء عبر منصات سابر أو
                المنصات ذات العلاقة الأخرى.
              </p>
              <p>
                يشمل ذلك إعداد الملفات الفنية والتقارير والوثائق المطلوبة لضمان
                قبول طلبات شهادات المطابقة بأقل قدر من الملاحظات.
              </p>
            </div>

            <div className="legal-block">
              <h2 className="legal-block-title">شهادات الأنظمة الإدارية والجودة</h2>
              <p>
                نعمل مع شركاء متخصصين لمساندة العملاء في تبنّي أنظمة إدارة الجودة
                والسلامة الغذائية وغيرها من المعايير، مثل ISO وHACCP، وتجهيز
                المنشأة للحصول على الشهادات ذات العلاقة.
              </p>
              <p>
                يهدف ذلك إلى رفع كفاءة التشغيل، وزيادة ثقة العملاء والجهات
                الرقابية في الأنشطة التي يقدّمها العميل في السوق.
              </p>
            </div>

            <div className="legal-block">
              <h2 className="legal-block-title">توثيق خبرات وإنجازات نبض كير</h2>
              <p>
                تعتمد نبض كير على سجل من الأعمال والملفات الناجحة مع عملاء في
                قطاعات مختلفة، ويتم توثيق هذه الخبرات داخليًا بما يحفظ سرية
                بيانات العملاء.
              </p>
              <p>
                يمكن مشاركة أمثلة عامة على النجاحات وقصص العمل دون الإشارة إلى
                أي بيانات حساسة أو تعريفية، وذلك لتعريف العملاء الجدد بطبيعة
                الخبرات المتوفرة لدى الفريق.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CertificatesPage;

